"use client"

import { Badge } from "@/components/ui/badge"
import type { FxSessionContext } from "@/lib/agent-force"

type Props = {
  session: FxSessionContext | null
}

export function SessionBadge({ session }: Props) {
  if (!session?.session) {
    return (
      <Badge variant="outline" className="text-xs font-normal">
        Session —
      </Badge>
    )
  }

  const overlap = session.is_overlap_london_ny
  const label = session.display_name ?? session.session

  return (
    <Badge
      variant={overlap ? "default" : "secondary"}
      className="shrink-0 max-w-none text-xs font-normal whitespace-nowrap sm:max-w-[200px] sm:truncate"
      title={session.active_sessions?.length ? `Active: ${session.active_sessions.join(", ")}` : label}
    >
      {label}
      {session.sl_multiplier != null && session.sl_multiplier !== 1 ? (
        <span className="ml-1 opacity-70">SL×{Number(session.sl_multiplier).toFixed(2)}</span>
      ) : null}
    </Badge>
  )
}
